import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { omit } from 'lodash-es';
import { FiltersPopover, FilterIcon, palette } from '@dev/ee-components';
import { usePaidNewsletterParamsFromUrl } from '@/components/PaidNewsletters/hooks/useRequestParams';

import dayjs from '@/services/tools/dayjs';
import { GetAllPaidNewslettersStart, getPaidNewslettersStore } from '@/store/paidNewsletters/actions';
import { DateDropdownOptions } from '@/services/dictionaries/DateRangeValues';
import { useMobileFilterTabs } from '../../hooks/useMobileFilterTabs';


const mobileFiltersApply = (filtersObj, params, selectedDateFrom, selectedDateTo, paidNewsletters, dispatch): void => {
    const dateValue = filtersObj[0];
    let from;
    let to;
    const { limit } = paidNewsletters;
    const rest = omit(paidNewsletters, ['statuses', 'page', 'limit']);

    switch (dateValue) {
        case DateDropdownOptions.Calendar:
            from = dayjs(selectedDateFrom).add(1, 'day').utc().hour(0).minute(0).format();
            to = dayjs(selectedDateTo).utc().format();
            break;
        case DateDropdownOptions.All:
            from = null;
            to = null;
            break;
        default:
            from = dayjs().subtract(dateValue, 'd').utc().hour(0).minute(0).format();
            break;
    }

    dispatch(
        GetAllPaidNewslettersStart({
            ...params,
            ...rest,
            limit,
            from,
            to
        })
    );
};

export const MobileFilters = (): JSX.Element => {
    const { t } = useTranslation();
    const filterTabs = useMobileFilterTabs();
    const paidNewsletters = useSelector(getPaidNewslettersStore);
    const dispatch = useDispatch();
    const params = usePaidNewsletterParamsFromUrl();

    const handleApply = (obj, selectedDateFrom, selectedDateTo): void => {
        mobileFiltersApply(obj, params, selectedDateFrom, selectedDateTo, paidNewsletters, dispatch);
    }
    return (
        <FiltersPopover
            onApply={handleApply}
            tabs={filterTabs}
            title={t('filters')}
            translations={{
                apply: t('apply'),
                close: t('close'),
            }}
        >
            <FilterIcon color={palette.gray[6]} width={20} height={20} />
        </FiltersPopover>
    );
};